<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-remove-bookshelf`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 4h32c-1.333 2.667-2 5.333-2 8s.667 5.333 2 8H12a8 8 0 110-16zm32 28a8 8 0 00-8-8H4l.228.47C5.41 26.98 6 29.49 6 32l-.007.47C5.92 34.98 5.255 37.49 4 40h10v-4.001L9.6 36l.105-.569A20.201 20.201 0 009.6 28H36l.2.005A4 4 0 0140 32l-.005.2A4 4 0 0136 36l-2-.001V40h2l.25-.004A8 8 0 0044 32zm-20.5 2.672l-2.475-2.475a1 1 0 00-1.414 0l-1.414 1.414a1 1 0 000 1.414l2.475 2.475-2.475 2.475a1 1 0 000 1.414l1.414 1.414a1 1 0 001.414 0l2.475-2.475 2.475 2.475a1 1 0 001.414 0l1.414-1.414a1 1 0 000-1.414L26.328 37.5l2.475-2.475a1 1 0 000-1.414l-1.414-1.414a1 1 0 00-1.414 0L23.5 34.672zM11.8 15.995l.1.004h.051l-.017-.001-.134-.003zM12 8h26.4a20.345 20.345 0 00-.392 3.426l-.006.374L38 12v.064c.004 1.318.139 2.63.4 3.936H12a4 4 0 110-8z"/></svg>
</template>
<script>

export default {
  name: 'IconRemoveBookshelf',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
